export const handleChangeRequest = () => {
  alert('Please change your account in MetaMask.')
  // we can use a more user-friendly notification or modal instead of alert.
}
